import { IShortcutList, IShortcutListRequest } from 'core/model/interfaces/shortcuts';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../shortcuts.constants';
import { IShortcutsState } from '../shortcuts.types';

export const fetchShortcuts = createAppAsyncThunk<IShortcutList, void | IShortcutListRequest>(
  `${SLICE_NAMESPACE}/fetchShortcuts`,
  async (data, { getState }) => {
    try {
      const { query, priceListIds } = data || {};
      const { shortcuts } = getState();
      const { shortcutListPagination } = shortcuts;
      const { currentPage, itemsPerPage } = shortcutListPagination;

      return await apiService.shortcuts.getShortcutList({
        query: query || undefined,
        page: currentPage,
        itemsPerPage,
        priceListIds: priceListIds || [],
      });
    } catch (error) {
      notificationService.global.error(handleErrorMessage(error, 'Falló al obtener la lista de shortcuts.'));

      throw error;
    }
  },
);

export const fetchShortcutsReducer: TSliceExtraReducer<IShortcutsState> = builder =>
  builder
    .addCase(fetchShortcuts.pending, state => {
      state.shortcutList.isLoading = true;
    })
    .addCase(fetchShortcuts.rejected, state => {
      state.shortcutList.data = [];
      state.shortcutList.isLoading = false;
    })
    .addCase(fetchShortcuts.fulfilled, (state, action) => {
      state.shortcutList.data = action.payload.shortcuts;
      state.shortcutListPagination = action.payload.pagination;
      state.shortcutList.isLoading = false;
    });
